<template>
  <div class="tostMessage">
    <div class="icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="19" r="2" stroke="white" stroke-width="2"/>
        <path d="M9 3L10 14H14L15 3H9Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <p class="message m-body-m">{{ message }}</p>
    <svg @click="close()" class="close-button" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 8L16 16" stroke="#00050A" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M16 8L8 16" stroke="#00050A" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    message: String
  },
  methods: {
    close: function () {
      this.$emit('close', {
        close: false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.tostMessage {
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  min-height: 49px;
  z-index: 1000;
  border-radius: var(--default-br);
  background: var(--white);
  box-shadow: 0px 1px 4px #DCE1E6;
  box-sizing: border-box;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 49px;
    border-radius: var(--default-br) 0 0 var(--default-br);
    background: var(--red);
    box-shadow: 0px 1px 4px #DCE1E6;
  }

  .message {
    padding: 0 48px 0 12px;
    color: var(--black);
  }

  .close-button {
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;

    path {
      stroke: var(--grey-200);
    }
  }
}

</style>
